import React from 'react';
import { Shield, Scale, Tv, BookOpen, Handshake } from 'lucide-react';
const sections = [{
  icon: Shield,
  title: 'Unparalleled Expertise in Law Enforcement & Tactical Training',
  text: 'With extensive real-world experience, Medina Tactical Dynamics brings a deep understanding of law enforcement operations, use-of-force scenarios, and emergency response strategies. Our team has trained police academies, developed elite Emergency Services Units, and led hundreds of high-risk warrant operations with successful outcomes.'
}, {
  icon: Scale,
  title: 'Innovative Security Solutions & Legal Consulting',
  text: 'We go beyond conventional training by integrating legal case law into Police-SWAT programs, providing law enforcement professionals with critical insights into use-of-force decision-making. Our expertise also extends to legal consulting for law firms, active officer-involved shooting investigations, and workplace violence prevention.',
  extra: 'One of our landmark achievements includes developing the first-ever Active Shooter Emergency Response Plan (ASERP) for the Port Authority Police of NY/NJ, enhancing security at major international airports in the tri-state area.'
}, {
  icon: Tv,
  title: 'Trusted Industry Leaders & Media Experts',
  text: 'Medina Tactical Dynamics is a recognized authority in security and emergency preparedness. Our team has provided expert analysis for major news networks, covering topics such as workplace violence, legal use-of-force assessments, self-protection strategies, and homeland security readiness.'
}, {
  icon: BookOpen,
  title: 'Comprehensive Training & Safety Programs',
  text: 'We offer specialized safety consulting, emergency response planning, threat assessments, and investigative services for businesses and individuals. Our firm also conducts one of the most comprehensive 12-hour Concealed Carry and Basic Firearms Safety Programs in New Jersey, ensuring responsible firearm training and public safety.'
}, {
  icon: Handshake,
  title: 'Partner with Medina Tactical Dynamics',
  text: "With a commitment to excellence, innovation, and real-world expertise, Medina Tactical Dynamics is your trusted partner for advanced security solutions and tactical training. Contact us today to learn how our services can enhance your organization's safety and operational readiness."
}];
export function ExpertiseSections() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-523">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-524">
        <div className="space-y-12" data-id="element-525">
          {sections.map(section => {
          const Icon = section.icon;
          return <div key={section.title} className="bg-brand-black p-8 md:p-10 border border-brand-gray-800" data-id="element-526">
                <div className="flex items-start gap-6" data-id="element-527">
                  <div className="w-12 h-12 bg-brand-teal/10 border border-brand-teal/30 flex items-center justify-center flex-shrink-0" data-id="element-528">
                    <Icon className="w-6 h-6 text-brand-teal" data-id="element-529" />
                  </div>
                  <div data-id="element-530">
                    <h3 className="text-xl font-bold text-brand-white uppercase tracking-wide mb-4" data-id="element-531">
                      {section.title}
                    </h3>
                    <p className="text-brand-gray-300 leading-relaxed text-lg" data-id="element-532">
                      {section.text}
                    </p>
                    {section.extra && <p className="text-brand-gray-300 leading-relaxed text-lg mt-4" data-id="element-533">
                        {section.extra}
                      </p>}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}